import React from 'react'
import { useCart } from '../../../hooks/useCart'
import { Product } from '../../../util/typings'
import {getSizedImageUrl} from '@shopify/theme-images';
import Money from '../../Money';

type Props = {
    subscriptionUpsellProduct: Product,
    subscriptionUpsellSellingPlan: number
    subscriptionUpsellHeading: string
    subscriptionUpsellSubtitle: string
    subscriptionUpsellBorder: string
    langStrings: Record<string, string>
}

const SubscriptionUpsell: React.FunctionComponent<Props> = ({ langStrings, subscriptionUpsellSellingPlan, subscriptionUpsellHeading, subscriptionUpsellSubtitle, subscriptionUpsellBorder, subscriptionUpsellProduct }: Props) => {

  const { addToCart } = useCart()
  const productVariant = subscriptionUpsellProduct.variants[0]

  return (
    <div className="minicart-subscription-upsell-snippet">
      <h3 className="minicart-subscription-upsell-title">
        {subscriptionUpsellHeading}
      </h3>

      <div className="minicart-subscription-upsell__wrapper pink-container" style={{border: `1px solid ${subscriptionUpsellBorder}`}}>
        <div className="minicart-subscription-upsell__image">
          <img alt={subscriptionUpsellProduct.title} loading="lazy" width="112" height="168" src={getSizedImageUrl(subscriptionUpsellProduct.images[1], '224x336')}></img>
        </div>

        <div className="minicart-subscription-upsell__inner">
          <div className="minicart-subscription-upsell__info">
            <p className="minicart-subscription-upsell__info__subtitle">
              <a href={`/products/${subscriptionUpsellProduct.handle}`}>{subscriptionUpsellSubtitle}</a>
            </p>
            <p className="minicart-subscription-upsell__info__title">
              <a href={`/products/${subscriptionUpsellProduct.handle}`}>{subscriptionUpsellProduct.title}</a>
            </p>
            <p className="minicart-subscription-upsell__info__price" data-upsell-price="">
              {productVariant.compare_at_price !== null ? <s><Money amount={productVariant.compare_at_price} /></s> : null }
              <Money amount={productVariant.price} />
            </p>
          </div>

          <button
            className="btn btn--primary"
            onClick={() => addToCart([{id: productVariant.id, quantity: 1, sellingPlan: subscriptionUpsellSellingPlan}], true)}
            type="button">
            {productVariant.available ? langStrings.addToCart : langStrings.soldOut }
          </button>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionUpsell